"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _FormControlLabel2 = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Checkbox2 = _interopRequireDefault(require("@mui/material/Checkbox"));
var _Autocomplete2 = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select2 = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem2 = _interopRequireDefault(require("@mui/material/MenuItem"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _InputAdornment2 = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Button3 = _interopRequireDefault(require("@mui/material/Button"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _findIllus = _interopRequireDefault(require("../../../assets/images/find-illus.svg"));
var _hooks = require("../../../hooks");
var _services = require("../../../services");
var _icons = require("../../icons");
var _sizes = require("../sizes");
var _item = _interopRequireDefault(require("./item"));
var _rankCard = _interopRequireDefault(require("./rank-card"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function CompaniesLeaderboard({
  Button: _Button,
  event,
  ownGeogroup,
  selectedLeaderboardSize,
  search,
  selectedZone,
  sitesDisplayed,
  setSearch,
  selectSize,
  selectZone,
  displaySites,
  onOwnCompanyClick
}) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const [tmpSearch, setTmpSearch] = (0, _react.useState)(search);
  const [cyclabilityZoneSearch, setCyclabilityZoneSearch] = (0, _react.useState)('');
  const [cyclabilityZoneSearchResults, setCyclabilityZoneSearchResults] = (0, _react.useState)();
  const [page, setPage] = (0, _react.useState)(1);
  const [leaderboard, setLeaderboard] = (0, _react.useState)();
  const [count, setCount] = (0, _react.useState)();
  const [ownItem, setOwnItem] = (0, _react.useState)();
  const [loading, setLoading] = (0, _react.useState)(false);
  const locked = (0, _react.useRef)(false);
  const fetch = (0, _react.useMemo)(() => (0, _debounce.default)(async (search, callback) => {
    if (locked.current) {
      callback([]);
      locked.current = false;
      return;
    }
    const {
      zones: cyclabilityZones
    } = await _services.CyclabilityZoneService.getZones({
      administrativeLevels: ['CITY', 'EPCI', 'DEPARTMENT', 'REGION'],
      query: '{id, administrative_level, geo_polygon, name}',
      search,
      rowsPerPage: 5
    });
    callback(cyclabilityZones);
  }, 400), []);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    if (ownGeogroup !== undefined) setInitialized(true);
  }, [ownGeogroup]);
  (0, _react.useEffect)(() => {
    if (initialized) {
      if (page > 1) setPage(1);
      getLeaderboard(1);
    }
    return () => {
      cancelPromises();
      setLeaderboard(undefined);
      setCount(undefined);
      setOwnItem(undefined);
    };
  }, [initialized, search, selectedLeaderboardSize, selectedZone, sitesDisplayed]);
  (0, _react.useEffect)(() => {
    if (page > 1) getLeaderboard(page);
  }, [page]);
  (0, _react.useEffect)(() => {
    let active = true;
    setCyclabilityZoneSearchResults(undefined);
    if (!cyclabilityZoneSearch || cyclabilityZoneSearch.length < 3) return;
    fetch(cyclabilityZoneSearch, cyclabilityZones => {
      if (active) setCyclabilityZoneSearchResults(cyclabilityZones);
    });
    return () => {
      active = false;
    };
  }, [cyclabilityZoneSearch, fetch]);
  async function getLeaderboard(page) {
    setLoading(true);
    try {
      const size = selectedLeaderboardSize ? selectedLeaderboardSize === 'small' ? {
        max: 50
      } : selectedLeaderboardSize === 'medium' ? {
        min: 51,
        max: 500
      } : {
        min: 501
      } : undefined;
      const isOwnGeogroupSize = ownGeogroup && (!selectedLeaderboardSize || selectedLeaderboardSize === ownGeogroup.companySize) && !sitesDisplayed;
      const returnedGroupsMode = sitesDisplayed ? selectedZone ? 'sitesOrCompaniesWithoutSites' : 'groupsAndSites' : selectedZone ? 'aggregatedGroupsAndSites' : 'excludeSubgroups';
      const [{
        count,
        items
      }, {
        items: [ownItem]
      }] = await cancellablePromise(Promise.all([_services.EventService.getRanking(event.id, {
        page,
        pageSize: 50,
        groupTypes: ['company'],
        returnedGroupsMode,
        size,
        search,
        cyclabilityZoneId: selectedZone ? selectedZone.id : undefined
      }), isOwnGeogroupSize && page === 1 ? _services.EventService.getRanking(event.id, {
        page,
        pageSize: 1,
        groupTypes: ['company'],
        returnedGroupsMode,
        size,
        search,
        cyclabilityZoneId: selectedZone ? selectedZone.id : undefined,
        groupsIds: [ownGeogroup.id]
      }) : {
        items: []
      }]));
      setCount(count);
      if (page === 1) {
        setLeaderboard(items);
        setOwnItem(ownItem || null);
      } else setLeaderboard([...(leaderboard || []), ...items]);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
    setLoading(false);
  }
  const size = selectedLeaderboardSize || 'none';
  const Button = _Button || _Button3.default;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3,
    sx: {
      containerType: 'inline-size'
    },
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    margin: "none",
    onChange: ({
      currentTarget: {
        value
      }
    }) => setTmpSearch(value),
    onKeyDown: ({
      key
    }) => {
      if (key === 'Enter') setSearch(tmpSearch);
    },
    placeholder: t('commons.challenges.leaderboard.search_company'),
    size: "small",
    slotProps: {
      input: {
        endAdornment: tmpSearch && /*#__PURE__*/_react.default.createElement(_InputAdornment2.default, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
          title: "Rechercher"
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
          disabled: !tmpSearch,
          onClick: () => setSearch(tmpSearch),
          size: "small"
        }, /*#__PURE__*/_react.default.createElement(_icons.SearchIcon, {
          fontSize: "small"
        })))))
      }
    },
    sx: {
      '.MuiInputBase-root': {
        bgcolor: '#fff'
      }
    },
    type: "text",
    value: tmpSearch,
    variant: "outlined"
  }), (selectSize || selectZone || displaySites) && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row'
    },
    gap: 1
  }, selectSize && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    width: {
      '@': '100%',
      '@500': 'calc((100% - 8px) / 3)'
    }
  }, /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    fullWidth: true,
    margin: "none"
  }, /*#__PURE__*/_react.default.createElement(_Select2.default, {
    onChange: ({
      target: {
        value
      }
    }) => selectSize(value === 'none' ? null : value),
    size: "small",
    value: size
  }, /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    value: "none"
  }, t('commons.challenges.leaderboard.label_companies_all')), _sizes.leaderboardSizes.map(key => /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    key: key,
    value: key
  }, t(_sizes.leaderboardSizesMap[key].labelKey)))))), selectZone && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    borderRadius: 2,
    display: "flex",
    width: {
      '@': '100%',
      '@500': 'calc((100% - 8px) / 3)'
    }
  }, /*#__PURE__*/_react.default.createElement(_Autocomplete2.default, {
    disablePortal: true,
    fullWidth: true,
    includeInputInList: true,
    forcePopupIcon: Boolean(cyclabilityZoneSearch && !selectedZone),
    getOptionKey: option => option.id,
    getOptionLabel: option => option.name,
    isOptionEqualToValue: (option, value) => option.id === value.id,
    loading: Boolean(cyclabilityZoneSearch) && !selectedZone,
    loadingText: t('commons.loading'),
    noOptionsText: cyclabilityZoneSearch && t('commons.no_result_found'),
    onChange: (_, value) => {
      locked.current = true;
      selectZone(value || null);
    },
    onInputChange: (_, value) => setTimeout(() => setCyclabilityZoneSearch(value), 10),
    options: cyclabilityZoneSearchResults || [],
    renderInput: params => /*#__PURE__*/_react.default.createElement(_TextField2.default, _extends({}, params, {
      fullWidth: true,
      margin: "none",
      placeholder: t('commons.challenges.leaderboard.search_zone'),
      size: "small",
      variant: "outlined"
    })),
    value: selectedZone
  })), displaySites && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: 2,
    display: "flex",
    width: {
      '@': '100%',
      '@500': 'calc((100% - 8px) / 3)'
    }
  }, /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    fullWidth: true,
    component: "fieldset",
    margin: "none"
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
      checked: sitesDisplayed,
      color: "primary",
      name: "sendDataToPartner",
      onChange: (_, checked) => displaySites(checked),
      size: "small",
      value: sitesDisplayed
    }),
    label: t('commons.challenges.leaderboard.display_sites'),
    sx: {
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 0.5,
      paddingRight: 2
    }
  }))))), /*#__PURE__*/_react.default.createElement(_rankCard.default, {
    challengeTemplate: event.challengeTemplate,
    numberOfParticipants: count,
    progress: ownItem
  }), !leaderboard || leaderboard.length > 0 ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: "1px solid #dde0e7",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#F6F8FC",
    display: "flex",
    gap: 1,
    justifyContent: "flex-start",
    paddingX: 2,
    paddingY: 1,
    sx: {
      textAlign: 'left',
      textTransform: 'initial',
      color: 'initial'
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 30
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "body2"
  }, t('commons.communities.form.types.company'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 100
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700,
    variant: "body2"
  }, t('commons.challenge_details.table.participants'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 100
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700,
    variant: "body2"
  }, t('commons.challenge_details.table.average_per_participant'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 80
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "right",
    fontWeight: 700,
    variant: "body2"
  }, t('commons.challenge_details.table.performance', {
    context: event.challengeTemplate?.type === 'bttf' ? 'bttf' : event.challengeTemplate?.type === 'traveledDistance' ? 'distance' : event.challengeTemplate?.type === 'cyclingDays' ? 'days' : event.challengeTemplate?.type === 'homeWorkJourneysCount' || event.challengeTemplate?.type === 'journeysCount' ? 'journeys' : ''
  })))), leaderboard ? leaderboard.map((item, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: item.id
  }, /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    enableParticipants: true,
    challengeType: event.challengeTemplate?.type,
    item: item,
    onOwnCompanyClick: onOwnCompanyClick,
    ownGeogroup: ownGeogroup,
    prevItemRank: index > 0 ? leaderboard[index - 1].rank : null
  }))) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    enableParticipants: true,
    challengeType: event.challengeTemplate?.type,
    prevItemRank: null
  })))) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 5
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 64,
    src: _findIllus.default
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, t('commons.challenges.leaderboard.empty_state_title_company')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, t('commons.challenges.leaderboard.empty_state_description')))), leaderboard && count && count > leaderboard.length ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: loading,
    endIcon: loading && /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }),
    onClick: () => setPage(page + 1),
    size: "small",
    variant: "outlined"
  }, t('commons.actions.see_more'))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
}
var _default = exports.default = CompaniesLeaderboard;